import React from 'react'
import ClassNames from 'classnames'
import { InputUploadStyle } from './styled'
import { Button, Section } from '../../components'

/**
 * Input description
 * - ...
 */

export class InputUpload extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      selectedFile: undefined,
    }
  }

  // On file select (from the pop up)
  onFileChange = event => {
    // Update the state
    this.setState({ selectedFile: event.target.files[0] })
  }

  render() {
    const {
      className,
      label,
      value,
      id,
      name,
      browseButtonText,
      //uploadButtonText,
      placeholder,
      isHorizontal,
      isDisable,
      disabled,
      isDisabled,
      readOnly,
      isReadOnly,
      onChange,
      selectedFileName,
      accept,
      //onClickUpload,
      isHideIput,
      style,
    } = this.props

    const { selectedFile } = this.state
    return (
      <InputUploadStyle
        className={ClassNames(
          'input-upload-control',
          { 'is-horizontal': isHorizontal },
          { 'is-disabled': isDisable || disabled || isDisabled },
          { 'is-read-only': readOnly || isReadOnly },
          { 'is-hide-fake-input': isHideIput },
          className
        )}
      >
        {label && (
          <label className="label" htmlFor={id}>
            {label}
          </label>
        )}
        <label className="fake-input-label" htmlFor={id}>
          <Section>
            <input
              className="fake-input"
              placeholder={placeholder}
              onClick={e => (e.target.value = null)}
              value={
                selectedFileName && onChange
                  ? selectedFileName
                  : selectedFile
                  ? selectedFile.name
                  : ''
              }
              readOnly
            />
            <Button style={style} className="browse-file" isDisable={isDisable}>
              {browseButtonText}
            </Button>
          </Section>
        </label>
        <input
          className="real-input"
          type="file"
          id={id}
          name={name}
          placeholder={placeholder}
          disabled={isDisable || disabled || isDisabled}
          value={value}
          readOnly={readOnly || isReadOnly}
          onClick={e => (e.target.value = null)}
          onChange={onChange ? onChange : this.onFileChange}
          accept={accept}
        />
        {/* {this.state.selectedFile && (
          <Button onClick={onClickUpload}>{uploadButtonText}</Button>
        )} */}
      </InputUploadStyle>
    )
  }
}

InputUpload.defaultProps = {
  browseButtonText: 'Browse..',
  uploadButtonText: 'Upload',
  isHorizontal: true,
}
